import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2Icon, TargetIcon, EyeIcon, AwardIcon, ArrowRightIcon } from 'lucide-react';
export function AboutPage() {
  return <div className="pt-20" data-id="element-223">
      <section className="bg-brand-navy py-24 text-white" data-id="element-224">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-225">
          <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-226">
            About Global Restorative
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-227">
            Restoring Health. Renewing Minds. Rebuilding Lives.
          </p>
        </div>
      </section>

      <section className="py-24 bg-white" data-id="element-228">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-229">
          <div className="grid lg:grid-cols-2 gap-16 items-center mb-24" data-id="element-230">
            <div data-id="element-231">
              <h2 className="text-3xl font-bold text-brand-navy mb-6" data-id="element-232">
                Our Story & Mission
              </h2>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed" data-id="element-233">
                Global Restorative Health & Wellness LLC is a comprehensive
                healthcare and mental wellness organization dedicated to
                delivering holistic, compassionate, and evidence-based services.
              </p>
              <p className="text-lg text-gray-600 mb-8 leading-relaxed" data-id="element-234">
                Our mission is to restore health, promote emotional wellness,
                and empower individuals and families to live healthier, more
                meaningful, and purpose-driven lives.
              </p>
              <div className="bg-brand-light p-8 rounded-2xl border-l-4 border-brand-red" data-id="element-235">
                <h3 className="text-xl font-bold text-brand-navy mb-2 flex items-center" data-id="element-236">
                  <TargetIcon className="mr-2 text-brand-red" data-id="element-237" /> Our Vision
                </h3>
                <p className="text-gray-700" data-id="element-238">
                  To become a trusted leader in integrated healthcare and mental
                  wellness services locally, nationally, and globally.
                </p>
              </div>
            </div>
            <div className="relative" data-id="element-239">
              <img src="https://images.unsplash.com/photo-1576091160550-2173dba999ef?auto=format&fit=crop&q=80&w=1000" alt="Healthcare professional" className="rounded-2xl shadow-2xl" data-id="element-240" />
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-241">
            {[{
            title: 'Compassion',
            desc: 'We lead with heart in every interaction.'
          }, {
            title: 'Integrity',
            desc: 'Honesty and transparency in all we do.'
          }, {
            title: 'Excellence',
            desc: 'Commitment to the highest standards of care.'
          }].map(value => <div key={value.title} className="p-8 bg-brand-light rounded-2xl text-center" data-id="element-242">
                <AwardIcon className="h-10 w-10 text-brand-red mx-auto mb-4" data-id="element-243" />
                <h4 className="text-xl font-bold text-brand-navy mb-2" data-id="element-244">
                  {value.title}
                </h4>
                <p className="text-gray-600" data-id="element-245">{value.desc}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-brand-light" data-id="element-246">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-247">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-navy mb-6" data-id="element-248">
            Experience the Global Restorative Difference
          </h2>
          <p className="text-lg text-gray-600 mb-10" data-id="element-249">
            Our team is ready to support you in your journey towards holistic
            health and emotional wellness.
          </p>
          <Link to="/contact" className="inline-flex items-center bg-brand-red text-white px-10 py-4 rounded-xl font-bold text-lg hover:bg-brand-navy transition-all shadow-xl group" data-id="element-250">
            Start Your Journey
            <ArrowRightIcon className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" data-id="element-251" />
          </Link>
        </div>
      </section>
    </div>;
}